import { UrlBuilder } from "@lib-shared/lib";
import context from "core/tv-guide.context";
import { NewsListPackageResponse } from "core/types";
import { BaseService } from "./tv-guide.service";

class NewsService extends BaseService {
    constructor() {
        super("/umbraco/api/news");
    }

    async getNewsArticles($package: string) {
        const url = new UrlBuilder("GetNewsByPackage")
            .appendParam("useCamelCase", "true")
            .appendParam("package", $package);

        const culture = context.countryCode;

        if (culture) {
            url.appendParam("culture", culture);
        }

        return this.get<NewsListPackageResponse>(url);
    }
}

export default NewsService;